import { jsxs as S, jsx as o } from "react/jsx-runtime";
/* empty css                                                                    */
/* empty css                                                                                */
/* empty css                                                                                 */
import { clsx as w } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as A, useRef as c, useEffect as ve } from "react";
import { S as be } from "../../node_modules/.pnpm/swiper@12.1.3/node_modules/swiper/shared/swiper-core.js";
import he from "../../node_modules/.pnpm/swiper@12.1.3/node_modules/swiper/modules/pagination.js";
import Ee from "../../node_modules/.pnpm/swiper@12.1.3/node_modules/swiper/modules/a11y.js";
import _e from "../../node_modules/.pnpm/swiper@12.1.3/node_modules/swiper/modules/autoplay.js";
import Se from "../../node_modules/.pnpm/swiper@12.1.3/node_modules/swiper/modules/effect-fade.js";
import { remCalc as we } from "../../style/base/index.js";
import { usePrefersReducedMotion as Ae } from "../../utils/use-prefers-reduced-motion.js";
import { RocheUIIcon as k } from "../icon/roche-icon.js";
import n from "./roche-slider.module.scss.js";
import { RocheUISlideAnimation as N, RocheUISlideDirection as R, RocheUISlideTransition as Ne } from "./roche-slider.types.js";
import { getAnimationSpeedForAnimationType as Re, getSlidesPerViewForMediumBreakpoint as Le, rocheUISliderBreakpoints as Ie, getAutoplayConfig as Pe, getEffectForAnimationType as Ce, toggleSlidesAccessibilityVisibility as D, getCurrentPageIndex as te, DEFAULT_AUTOPLAY_INTERVAL_SECONDS as Oe } from "./roche-slider-helpers.js";
const xe = 1.04, Je = ({
  id: B,
  slidesPerPage: m,
  nextSlideLabel: re,
  prevSlideLabel: ne,
  trackSlide: g,
  transition: M = Ne.BY_PAGE,
  animation: u = N.ENTER_FROM_RIGHT,
  items: l,
  slot: se,
  autoplay: oe = !1,
  autoplayDelaySeconds: H = Oe,
  pauseSlideshowLabel: ie,
  playSlideshowLabel: ae,
  topPadding: ce = !1,
  bottomPadding: ue = !1
}) => {
  const L = `${we(36)}rem`, [le, V] = A(!0), [pe, $] = A(!1), [j, f] = A(!1), [y, I] = A(!1), p = c(null), s = c(null), v = c(0), i = c(null), P = c(!1), C = c(!1), O = c(!1), G = c(null), Y = Ae(), b = Y && u !== N.CROSSFADE ? 0 : Re(u), q = (l == null ? void 0 : l.length) ?? 0, h = u === N.CROSSFADE ? 1 : m, x = Le(h), d = oe && !Y, E = d && q > m, X = () => C.current || O.current, _ = (t) => {
    var a;
    (a = G.current) == null || a.style.setProperty("--autoplay-progress", String(t));
  }, T = (t) => {
    V(t.isBeginning), $(t.isEnd);
  };
  ve(() => {
    var Z;
    if (!p.current) {
      (Z = s.current) == null || Z.destroy(), s.current = null, V(!0), $(!1), f(!1), I(!1);
      return;
    }
    p.current.style.setProperty("--slides-per-page", String(h)), p.current.style.setProperty("--slides-per-page-medium", String(x)), P.current = !1, s.current = new be(p.current, {
      a11y: { enabled: !0 },
      modules: [he, Se, Ee, _e],
      watchSlidesProgress: !0,
      watchOverflow: !0,
      noSwipingClass: "vjs-control-bar",
      navigation: !1,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        renderFraction(e, r) {
          return document.documentElement.getAttribute("dir") === "rtl" ? `<span class="${r}"></span>/<span class="${e}"></span>` : `<span class="${e}"></span>/<span class="${r}"></span>`;
        }
      },
      on: {
        init: (e) => {
          T(e), D(e), f(e.isLocked), v.current = te(e);
        },
        slideChange: (e) => {
          T(e), D(e);
        },
        activeIndexChange: (e) => {
          const r = te(e);
          r !== v.current && (i.current && (g == null || g(r, v.current, B, i.current)), v.current = r);
        },
        resize: (e) => {
          T(e), D(e), f(e.isLocked);
        },
        touchEnd: (e) => {
          i.current = e.swipeDirection === "prev" ? R.PREVIOUS : R.NEXT, requestAnimationFrame(() => {
            i.current = null;
          });
        },
        autoplayStart: (e) => {
          if (e.isLocked) {
            e.autoplay.stop();
            return;
          }
          I(!0);
        },
        beforeTransitionStart: (e, r) => {
          if (i.current) {
            _(0);
            return;
          }
          r > 0 && _(xe);
        },
        autoplayTimeLeft: (e, r, ee) => {
          e.animating || _(1 - ee);
        },
        autoplayResume: (e) => {
          X() && e.autoplay.pause();
        },
        autoplayStop: () => {
          I(!1), _(0);
        },
        lock: (e) => {
          var r;
          f(!0), (r = e.autoplay) == null || r.stop();
        },
        unlock: (e) => {
          var r;
          f(!1), d && !P.current && ((r = e.autoplay) == null || r.start());
        }
      },
      effect: Ce(u),
      fadeEffect: {
        crossFade: u === N.CROSSFADE
      },
      speed: b,
      loop: E,
      autoplay: Pe(d, H),
      observer: !0,
      observeParents: !0,
      breakpoints: Ie(m, u, M)
    });
    const t = s.current.wrapperEl, a = () => {
      var r;
      const e = (r = s.current) == null ? void 0 : r.autoplay;
      e && !e.paused && e.pause();
    }, z = () => {
      var e;
      X() || (e = s.current) == null || e.autoplay.resume();
    }, W = ({ pointerType: e }) => {
      e === "mouse" && (C.current = !0, a());
    }, J = ({ pointerType: e }) => {
      e === "mouse" && (C.current = !1, z());
    }, K = () => {
      O.current = !0, a();
    }, Q = ({ relatedTarget: e }) => {
      e instanceof Node && t.contains(e) || (O.current = !1, z());
    };
    return d && (t.addEventListener("pointerenter", W), t.addEventListener("pointerleave", J), t.addEventListener("focusin", K), t.addEventListener("focusout", Q)), () => {
      var e;
      t.removeEventListener("pointerenter", W), t.removeEventListener("pointerleave", J), t.removeEventListener("focusin", K), t.removeEventListener("focusout", Q), s.current && (s.current.destroy(), s.current = null);
      for (const r of ((e = p.current) == null ? void 0 : e.querySelectorAll(".swiper-slide-blank")) ?? [])
        r.remove();
    };
  }, [
    u,
    b,
    H,
    d,
    h,
    x,
    B,
    q,
    E,
    m,
    g,
    M
  ]);
  const de = () => {
    s.current && (i.current = R.NEXT, s.current.slideNext(b), i.current = null);
  }, fe = () => {
    s.current && (i.current = R.PREVIOUS, s.current.slidePrev(b), i.current = null);
  }, me = () => {
    var a;
    const t = (a = s.current) == null ? void 0 : a.autoplay;
    t && (P.current = y, y ? t.stop() : t.start());
  }, ge = !!l && l.length > 0, F = !E && le, U = !E && pe, ye = {
    "--slides-per-page": h,
    "--slides-per-page-medium": x
  };
  return ge && /* @__PURE__ */ S(
    "div",
    {
      className: w(
        "swiper",
        ce && n["swiper--top-padding"],
        ue && n["swiper--bottom-padding"]
      ),
      ref: p,
      slot: se,
      style: ye,
      children: [
        d && !j && /* @__PURE__ */ S(
          "button",
          {
            className: n["swiper__button-autoplay-custom"],
            onClick: me,
            "aria-label": y ? ie : ae,
            type: "button",
            children: [
              /* @__PURE__ */ S("svg", { className: n["swiper__autoplay-progress"], viewBox: "0 0 40 40", "aria-hidden": "true", children: [
                /* @__PURE__ */ o("circle", { className: n["swiper__autoplay-track"], cx: "20", cy: "20", r: "18" }),
                /* @__PURE__ */ o(
                  "circle",
                  {
                    ref: G,
                    className: n["swiper__autoplay-elapsed"],
                    cx: "20",
                    cy: "20",
                    r: "18",
                    pathLength: "1"
                  }
                )
              ] }),
              /* @__PURE__ */ o("span", { className: n["swiper__button-icon-custom"], children: /* @__PURE__ */ o(k, { icon: y ? "pause-bare" : "play-bare", height: L, decorative: !0 }) })
            ]
          }
        ),
        /* @__PURE__ */ o("div", { className: "swiper-wrapper", children: l.map((t) => /* @__PURE__ */ o("div", { className: "swiper-slide", children: t.content }, t.key)) }),
        /* @__PURE__ */ o(
          "div",
          {
            className: w(
              n["swiper__controls-wrapper"],
              j && n["swiper__controls-wrapper--navigation-hidden"]
            ),
            children: /* @__PURE__ */ S("div", { className: n.swiper__controls, children: [
              /* @__PURE__ */ o(
                "button",
                {
                  className: w(n["swiper__button-prev-custom"], F && n["swiper__button--disabled"]),
                  onClick: fe,
                  disabled: F,
                  "aria-disabled": F,
                  "aria-label": ne,
                  type: "button",
                  children: /* @__PURE__ */ o("span", { className: n["swiper__button-icon-custom"], children: /* @__PURE__ */ o(k, { icon: "chevron-left", height: L, decorative: !0 }) })
                }
              ),
              /* @__PURE__ */ o("div", { className: "swiper-pagination" }),
              /* @__PURE__ */ o(
                "button",
                {
                  className: w(n["swiper__button-next-custom"], U && n["swiper__button--disabled"]),
                  onClick: de,
                  disabled: U,
                  "aria-disabled": U,
                  "aria-label": re,
                  type: "button",
                  children: /* @__PURE__ */ o("span", { className: n["swiper__button-icon-custom"], children: /* @__PURE__ */ o(k, { icon: "chevron-right", height: L, decorative: !0 }) })
                }
              )
            ] })
          }
        )
      ]
    }
  );
};
export {
  Je as RocheUISlider
};
